import { A_TEST } from './default-experiments-types';
import { AbTestOptions } from './domain/models/ab-test-options.model';

export const experiements: AbTestOptions[] = [{ name: 'profile-activation', variations: A_TEST }];
